import React, { useState, useContext, useEffect, useRef } from 'react';
import { AppDataContext } from "../AppDataContext"
import useNetwork from '../../useNetwork';
import { ConfirmDialog } from '../ConfirmDialog';
import { Loader } from '../Loader';
import { Helmet } from "react-helmet";

export function TaxCerts(props) {

    const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError, netFormPost } = useNetwork(true);

    const fileInput = useRef();

    const [message, setMessage] = useState(null);
    const [isError, setIsError] = useState(false);

	const [taxids, setTaxIds] = useState([]);
	const [selectedTaxId, setSelectedTaxId] = useState(null);

    const [state, setState] = useState('');
    const updateStateValue = (evt) => { setState(evt.target.value) };

    const [certificateId, setCertificateId] = useState('');
    const updateCertificateId = (evt) => { setCertificateId(evt.target.value) };

    const [expirationDate, setExpirationDate] = useState('');
    const updateExpirationDate = (evt) => {
        setExpirationDate(evt.target.value);
    };

    const [file, setFile] = useState()
    const updateFileValue = (evt) => { setFile(evt.target.files[0]) };
 
    const openConfirmModal = async (taxId) => {
        setIsError(false);
        setMessage(null);
		setSelectedTaxId(taxId);
    }
	const modalOkClicked = async () => {
		var errorMessage = await deleteTaxId(selectedTaxId);
        return errorMessage;
    }

    const deleteTaxId = async (taxId) => {

        const url = 'api/site/deletetaxid';

        const resp = await netRequest(url, { Param: taxId });

        if (resp.isError) {
            return "An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")";
		} else {
			var ids = [...taxids];//copy array
			// remove the removed tax id item.
			//let ix = ids.map(x => x.secureId).indexOf(taxId);
            const ix = ids.findIndex(x => x.secureId == taxId);
			if (ix > -1) {
				ids.splice(ix, 1);
			}

			setTaxIds(ids);

            return null;

        }

    };

    const loadTaxIds = async () => {
        const url = 'api/site/gettaxids/';

        const response = await netRequest(url);

        if (response.data != null) {
            setTaxIds(response.data);

            // find a certificate that is valid and not expired and update context
            let cert = response.data.find(x => { return x.valid && x.expired == false; });

            context.setTaxExemptTaxDocSecureId(cert?.secureId);
            
        }
    };

    useEffect(() => {
		if (context.isLoggedIn)
			loadTaxIds();

	}, [context.isLoggedIn]);


    const saveTaxDoc = async (taxId) => {

        setIsError(false);
        setMessage(null);
        
        if (state === '' || certificateId === '') {
            setIsError(true);
            setMessage("Please enter a state, certificate id and expiration date.");
            return;
        }
      
        // using formdata for file upload.
        var formData = new FormData();
        formData.append("taxIdState", state);
        formData.append("taxId", certificateId);
        formData.append("expirationDate", expirationDate);

        if (file) {

            formData.append('taxIdDoc', file);

        } else {
            setIsError(true);
            setMessage("Please choose a certificate file.");
            return;
        }
        
        const url = 'api/site/savetaxdoc';

        const resp = await netFormPost(url, formData);

        if (resp.isError) {
            setIsError(true);
            setMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
        } else {
           setIsError(false);
            setMessage("Your certificate has been added.");
            loadTaxIds();
            setCertificateId('');
            setState('');
            setExpirationDate('');
            setFile('');
            fileInput.current.value = '';
        } 

    }
 

    return (
        <>
            <Helmet>
                <title>Tax Certs</title>
            </Helmet>

			<ConfirmDialog cancelText="No" okText="Yes"
				okClicked={modalOkClicked}
                id="taxDeleteConfirmModal"
                headerText="Confirm Delete?"
                modalSize='modal-xl'
            >
                Are you sure you want to delete this Tax Id?
            </ConfirmDialog>

			<div class="row mt-3">
				<div class="col-12 mb-1">
					<h4 class="auction-grid-header">
						Tax Certificates
						<div class="divider mt-2"></div>
                    </h4>
                    {
                        message ? <div className={"alert " + (isError ? "alert-danger" : "alert-success")} >{message}</div> : ""
                    }
				</div>
			 
				 
		  
				<div class="col-12 mb-3">
						<div class="row">
                            {
                                taxids.map((t) => (
                                    <div class="col-12 col-md-6 mb-3">
                                        <div class="d-flex align-items-center pickup__content background-color__lighter p-3">
                                            <div class="d-inline me-3 fs-3">

                                                {t.valid == null ?
                                                    <i class="bi bi-shield"></i>
                                                    : t.valid && t.expired == false ?
                                                        <i class="bi bi-shield-fill-check"></i>
                                                        : t.valid && t.expired == true ?
                                                            <i class="bi bi-shield-fill-exclamation"></i>
                                                            :
                                                            <i class="bi bi-shield-slash-fill"></i>
                                                }

                                            </div>
                                            <div class="d-inline">
												<h4 class="mb-0 pb-0" >ID: <span data-cert-id="">{t.taxId}</span> (<span data-cert-state="">{t.state}</span>)</h4>
                                                <h5 class="mb-0 pb-0">Expiration Date: <span data-cert-expiry="">{t.expirationDate != null ? (new Date(t.expirationDate)).toLocaleDateString('en-US') : 'N/A' }</span></h5>
                                                <h5 class="mb-0 pb-0"><span data-cert-valid="">{t.valid == null ? 'Awaiting Validation' : t.valid ? (t.expired ? 'Expired' : 'Valid') : 'Not Valid - Contact Support' }</span></h5>
                                            </div>
                                            <div class="d-inline ms-auto">
												<a target="_blank" href={'api/site/TaxIdCertificate/' + t.secureId} class="btn btn-icon-only">
                                                    <i class="bi bi-download"></i>
                                                </a>
                                            </div>
                                            <div class="d-inline ms-1">
												<button class="btn btn-icon-only btn-secondary" data-bs-toggle="modal" data-bs-target="#taxDeleteConfirmModal" 
													onClick={evt => openConfirmModal(t.secureId)}>
                                                    <i class="bi bi-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
					</div>
				</div>
				<div class="col-12 mb-1">
					<h5 class="auction-grid-header">
						Add New Certificate
						<div class="divider mt-2"></div>
					</h5>
				</div>
				<div class="col-12 col-md-6 mb-3">
					<div class="input-group has-validation">
						<label for="state" class="form-label w-100">State<span>*</span></label>
						<select id="state" class="form-select form-select-sm" aria-label=".form-select-sm example" required
                                onChange={evt => updateStateValue(evt)}
                                value={state}>
                                <option value=""> </option>
                                <option value="AL">Alabama</option>
                                <option value="AK">Alaska</option>
                                <option value="AZ">Arizona</option>
                                <option value="AR">Arkansas</option>
                                <option value="CA">California</option>
                                <option value="CO">Colorado</option>
                                <option value="CT">Connecticut</option>
                                <option value="DE">Delaware</option>
                                <option value="DC">District Of Columbia</option>
                                <option value="FL">Florida</option>
                                <option value="GA">Georgia</option>
                                <option value="HI">Hawaii</option>
                                <option value="ID">Idaho</option>
                                <option value="IL">Illinois</option>
                                <option value="IN">Indiana</option>
                                <option value="IA">Iowa</option>
                                <option value="KS">Kansas</option>
                                <option value="KY">Kentucky</option>
                                <option value="LA">Louisiana</option>
                                <option value="ME">Maine</option>
                                <option value="MD">Maryland</option>
                                <option value="MA">Massachusetts</option>
                                <option value="MI">Michigan</option>
                                <option value="MN">Minnesota</option>
                                <option value="MS">Mississippi</option>
                                <option value="MO">Missouri</option>
                                <option value="MT">Montana</option>
                                <option value="NE">Nebraska</option>
                                <option value="NV">Nevada</option>
                                <option value="NH">New Hampshire</option>
                                <option value="NJ">New Jersey</option>
                                <option value="NM">New Mexico</option>
                                <option value="NY">New York</option>
                                <option value="NC">North Carolina</option>
                                <option value="ND">North Dakota</option>
                                <option value="OH">Ohio</option>
                                <option value="OK">Oklahoma</option>
                                <option value="OR">Oregon</option>
                                <option value="PA">Pennsylvania</option>
                                <option value="RI">Rhode Island</option>
                                <option value="SC">South Carolina</option>
                                <option value="SD">South Dakota</option>
                                <option value="TN">Tennessee</option>
                                <option value="TX">Texas</option>
                                <option value="UT">Utah</option>
                                <option value="VT">Vermont</option>
                                <option value="VA">Virginia</option>
                                <option value="WA">Washington</option>
                                <option value="WV">West Virginia</option>
                                <option value="WI">Wisconsin</option>
                                <option value="WY">Wyoming</option>
						</select>
					</div>
				</div>
				<div class="col-12 col-md-6 mb-3">
					<div class="input-group has-validation">
                        <label for="expirationDate" class="form-label w-100">Expiration Date <span>Leave empty if not applicable</span></label>                       
                        <input type="text" id="expirationDate" class="form-control" type="date" required
                            onChange={evt => updateExpirationDate(evt)}
                            value={expirationDate}
                        />
					</div>
				</div>
				<div class="col-12 col-md-6 mb-3">
					<div class="input-group has-validation">
                        <label for="certificateid" class="form-label w-100">Certificate ID<span>*</span></label>
                        <input maxLength="50" type="text" class="form-control" id="certificateid" placeholder="Certificate ID" required
                            onChange={evt => updateCertificateId(evt)}
                            value={certificateId}
                        />
							<div class="invalid-feedback">
								Enter Certificate ID.
							</div>
					</div>
				</div>
				<div class="col-12 col-md-6 mb-3">
					<div class="input-group has-validation">
						<label for="certificate" class="form-label w-100">Certificate<span>*</span></label>
                        <input type="file" class="form-control" placeholder="Certificate" required 
                            ref={fileInput}
                            onChange={evt => updateFileValue(evt)}
                        />
							<div class="invalid-feedback">
								Upload Certificate.
							</div>
					</div>
				</div>

                <div class="offset-lg-4 col-md-12 col-lg-4 align-self-center mb-3">
                    <button type="button" onClick={saveTaxDoc} class="btn btn-secondary btn-fill w-100">Save</button>
				</div>
            </div>

            <Loader loading={loading} />

        </>
    );

}
